<template>
    <div>
        <slot name="dialogBtn" />
        <el-dialog :title="titleTxt" width="500px" :append-to-body="true" :destroy-on-close="true" :visible.sync="dialogVisible" v-if="dialogVisible">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
                <el-form-item label="标签名称" prop="name" class="prop-item">
                    <el-input v-model="form.name" placeholder="请输入" maxlength="10" show-word-limit />
                </el-form-item>
                <el-form-item label="标签描述" prop="describe" class="prop-item">
                    <el-input v-model="form.describe" placeholder="请输入描述" maxlength="20" show-word-limit />
                </el-form-item>
                <el-form-item label="分类类型" prop="type" class="prop-item">
                    <el-select v-model="form.type" placeholder="请选择">
                        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应用场景" prop="useType" class="prop-item">
                    <el-checkbox-group v-model="form.useType">
                        <el-checkbox label="1" name="useType"
                            >基于标签组合实现多答案
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="在FAQ的画像功能里，通过不同标签的组合，定义该组合下返回的玩家答案。"
                                placement="bottom"
                            >
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-checkbox>
                        <el-checkbox label="2" name="useType">
                            文本组件答案显示标签
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="在FAQ的文本组件里，通过选择画像标签实时调用标签的内容，返回特定的值。"
                                placement="bottom"
                            >
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button round size="medium" @click="dialogVisible = false">
                    取消
                </el-button>
                <el-button round size="medium" type="primary" @click="submit">
                    确定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { addTagClass, editTagClass } from "../server";

export default {
    name: "TagEdit",
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        const validate1 = (rlue, value, callback) => {
            if (value.search(/[<>]/g) !== -1) {
                callback(new Error("标签名称不可携带<>,会有xss安全风险"))
            } else {
                callback()
            }
        };
        const validate2 = (rlue, value, callback) => {
            if (value.search(/[<>]/g) !== -1) {
                callback(new Error("标签描述不可携带<>,会有xss安全风险"))
            } else {
                callback()
            }
        };
        return {
            dialogVisible: false,
            titleTxt: this.data.type === "edit" ? "编辑标签分类" : "创建标签分类",
            form: this.data.tagData,
            rules: {
                name: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "标签名称不能为空"
                    },
                    { validator: validate1, trigger: "blur" },
                ],
                describe: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "标签描述不能为空"
                    },
                    { validator: validate2, trigger: "blur" },
                ],
                type: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "分类类型不能为空"
                    }
                ],
                useType: [
                    {
                        type: "array",
                        required: true,
                        message: "应用场景不能为空",
                        trigger: "change"
                    }
                ]
            },
            typeOptions: [
                {
                    value: "1",
                    label: "条件标签",
                }
            ]
        };
    },
    computed: {
        gameId() {
            return this.$store.state.zhiji.gameState.gameId;
        }
    },
    watch: {
        dialogVisible(val) {
            // eslint-disable-next-line no-unused-expressions
            !val && this.$refs.form && this.$refs.form.resetFields();
        },
        data: {
            handler(val) {
                this.form = val.tagData;
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.$slots.dialogBtn[0].elm.addEventListener("click", () => {
            this.dialogVisible = true;
        });
    },
    destroyed() {
        this.$slots.dialogBtn[0].elm.removeEventListener("click", () => {
            this.dialogVisible = false;
        });
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.saveAction();
                } else {
                    return false;
                }
            });
        },
        saveAction() {
            const handlers = {
                edit: this.editAction,
                add: this.addAction
            };
            handlers[this.data.type].call(null);
        },
        addAction() {
            addTagClass(this.form, this.gameId).then(() => {
                this.dialogVisible = false;
                this.$emit("submit", this.form);
            });
        },
        editAction() {
            editTagClass(this.form, this.gameId).then(() => {
                this.dialogVisible = false;
                this.$emit("submit", this.form);
            });
        }
    }
};
</script>

<style lang="less" scoped>
.prop-item:last-child {
    margin-bottom: 0;
    .el-checkbox-group {
        width: 70%;
        .el-checkbox {
            margin-bottom: 14px;
        }
    }
}
</style>
